export const SET_CURRENT_USER = 'SET_CURRENT_USER';

// Set logged in user
export const setCurrentUser = (decoded) => {
    return {
        type: SET_CURRENT_USER,
        payload: decoded
    }
};